import "../../styles/modal.css";

export default function OrderTypeDeleteModal({ ordertype, onClose, onConfirm }) {
  if (!ordertype) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div
        className="modalCard modalDanger"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modalDangerTitle">Supprimer le Type de Commande</h3>

        <p className="modalDangerText">
          Êtes-vous sûr de vouloir supprimer
          <strong> {ordertype.name}</strong> ?
        </p>

        <p className="modalDangerWarning">
          Cette action est irréversible.
        </p>

        <div className="modalActions">
          <button className="btnGhost" onClick={onClose}>
            Annuler
          </button>

          <button
            className="btnDanger"
            onClick={() => onConfirm(ordertype.id)}>
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
